import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

const TOKEN_KEY = "dd_admin_token";

export const getAdminToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setAdminToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(TOKEN_KEY);

const adminHeaders = () => ({ "X-Admin-Token": getAdminToken() });

// Public
export const submitQuote = (data) => api.post("/quotes", data).then((r) => r.data);
export const submitMeeting = (data) => api.post("/meetings", data).then((r) => r.data);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const getAvailability = (date) =>
    api.get("/meetings/availability", { params: { date } }).then((r) => r.data);

// Admin
export const adminLogin = (password) =>
    api.post("/admin/login", { password }).then((r) => r.data);

export const adminStats = () =>
    api.get("/admin/stats", { headers: adminHeaders() }).then((r) => r.data);

export const adminList = (resource) =>
    api.get(`/admin/${resource}`, { headers: adminHeaders() }).then((r) => r.data);

export const adminUpdateStatus = (resource, id, status) =>
    api
        .patch(`/admin/${resource}/${id}`, { status }, { headers: adminHeaders() })
        .then((r) => r.data);

export const adminDelete = (resource, id) =>
    api
        .delete(`/admin/${resource}/${id}`, { headers: adminHeaders() })
        .then((r) => r.data);
